// extracted by mini-css-extract-plugin
export default {"Step-five":"StepFive_Step-five__SYQJp","checkbox-container":"StepFive_checkbox-container__-vvPu","link":"StepFive_link__cbBPV"};